import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={17}
    viewBox="0 0 16 17"
    fill={props.fill || "none"}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.9776 4.5008C14.1558 4.5008 15.1109 5.49401 15.1109 6.71918V8.11125C15.1109 8.3263 15.0658 8.53877 14.9787 8.73383C14.8917 8.9289 14.7647 9.10188 14.6068 9.24071C14.3503 9.46622 14.222 9.72872 14.222 10.0283C14.222 10.3278 14.3503 10.5903 14.6068 10.8158C14.7647 10.9546 14.8917 11.1276 14.9787 11.3227C15.0658 11.5178 15.1109 11.7302 15.1109 11.9453V13.3373C15.1109 14.5625 14.1558 15.5557 12.9776 15.5557H3.022C1.8438 15.5557 0.888672 14.5625 0.888672 13.3373V11.9453C0.888672 11.7302 0.933776 11.5178 1.02084 11.3227C1.1079 11.1276 1.23483 10.9546 1.39277 10.8158C1.6493 10.5903 1.77757 10.3278 1.77757 10.0283C1.77757 9.72874 1.6493 9.46622 1.39277 9.24075C1.23482 9.10191 1.10789 8.92893 1.02083 8.73385C0.933765 8.53877 0.888665 8.32629 0.888672 8.11123V6.7192C0.888672 5.49401 1.8438 4.50082 3.022 4.50082H12.9776V4.5008ZM5.79533 8.14265C5.44542 8.14265 5.16109 8.43468 5.15544 8.79716L5.15534 8.80816V11.2484C5.15534 11.6159 5.44188 11.9139 5.79533 11.9139C6.14527 11.9139 6.4296 11.6219 6.43525 11.2594L6.43533 11.2484V8.80816C6.43533 8.44061 6.1488 8.14265 5.79533 8.14265ZM10.4174 1.46733C11.564 1.03336 12.8462 1.68956 13.2814 2.93281L13.4987 3.55364C13.5065 3.57598 13.509 3.59995 13.506 3.62352C13.503 3.64709 13.4946 3.66956 13.4815 3.68904C13.4684 3.70851 13.451 3.72441 13.4307 3.73539C13.4104 3.74637 13.3879 3.7521 13.365 3.7521H5.18725C5.15381 3.75211 5.12144 3.73986 5.09582 3.71751C5.07021 3.69516 5.05298 3.66413 5.04718 3.62989C5.04137 3.59564 5.04735 3.56037 5.06408 3.53026C5.0808 3.50014 5.10719 3.47712 5.13862 3.46524L10.4174 1.46733Z"
      fill="url(#paint0_linear_14128_553)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14128_553"
        x1={1.00988}
        y1={2.387}
        x2={15.3397}
        y2={2.67045}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3C7BEA" />
        <stop offset={1} stopColor="#3C6DEA" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
